const page1 = {
  data: [
    {
      id: 2,
      date: '24 Jun 2019',
      time: '17:50',
      direction: 'Game product',
      game: 'Slots Era',
      platform: 'ios',
      event_type: 'event_split',
      description:
        'Выключен из раздачи на новичков сплит 106(расчёт среднего чека на сервере с постоянным коэффициентом 0,4). Изменили значения подсплитов settings:2 (было 8), averageCheck:0 (было 1) - т.о. мы перевели всех игроков этого сплита с серверного расчёта среднего чека на клиентский расчёт. Финализирован сплит 105(дефолт, с расчётом среднего чека на клиенте). Коэффициент раздачи сплита игрокам увеличен до 80',
      app_version: 'min_1.44.0',
      notes: 'https://wiki.murka.com/pages/viewpage.action?pageId=228526821',
      responsible: 'Алёна Костина',
    },
    {
      id: 3,
      date: '15 Jun 2019',
      time: '14:30',
      direction: 'Game product',
      game: 'Slots Era',
      platform: 'android',
      event_type: 'client_release',
      description: 'Переподали версию 1.45.0 на 100% аудитории',
      app_version: '1.45.0',
      notes: 'https://wiki.murka.com/pages/viewpage.action?pageId=222177720',
      responsible: 'user.vetal',
    },
    {
      id: 4,
      date: '20 Jun 2019',
      time: '15:30',
      direction: 'Game product',
      game: 'Scatter Slots',
      platform: 'android',
      event_type: 'client_release',
      description: 'Переподали версию 1.45.0 на 100% аудитории',
      app_version: '1.45.0',
      notes: 'https://wiki.murka.com/pages/viewpage.action?pageId=222177720',
      responsible: 'Фадий Исбер',
    },
    {
      id: 5,
      date: '17 Jun 2019',
      time: '17:30',
      direction: 'Game product',
      game: 'Slots Era',
      platform: 'android',
      event_type: 'client_release',
      description: 'Переподали версию 1.45.0 на 100% аудитории',
      app_version: '1.45.0',
      notes: 'https://wiki.murka.com/pages/viewpage.action?pageId=222177720',
      responsible: 'user.vetal',
    },
    {
      id: 6,
      date: '24 Jun 2019',
      time: '17:50',
      direction: 'Game product',
      game: 'Slots Era',
      platform: 'ios',
      event_type: 'event_split',
      description:
        'Выключен из раздачи на новичков сплит 106(расчёт среднего чека на сервере с постоянным коэффициентом 0,4). Изменили значения подсплитов settings:2 (было 8), averageCheck:0 (было 1) - т.о. мы перевели всех игроков этого сплита с серверного расчёта среднего чека на клиентский расчёт. Финализирован сплит 105(дефолт, с расчётом среднего чека на клиенте). Коэффициент раздачи сплита игрокам увеличен до 80',
      app_version: 'min_1.44.0',
      notes: 'https://wiki.murka.com/pages/viewpage.action?pageId=228526821',
      responsible: 'Алёна Костина',
    },
    {
      id: 7,
      date: '15 Jun 2019',
      time: '14:30',
      direction: 'Game product',
      game: 'Slots Era',
      platform: 'android',
      event_type: 'client_release',
      description: 'Переподали версию 1.45.0 на 100% аудитории',
      app_version: '1.45.0',
      notes: 'https://wiki.murka.com/pages/viewpage.action?pageId=222177720',
      responsible: 'user.vetal',
    },
    {
      id: 8,
      date: '20 Jun 2019',
      time: '15:30',
      direction: 'Game product',
      game: 'Scatter Slots',
      platform: 'android',
      event_type: 'client_release',
      description: 'Переподали версию 1.45.0 на 100% аудитории',
      app_version: '1.45.0',
      notes: 'https://wiki.murka.com/pages/viewpage.action?pageId=222177720',
      responsible: 'Фадий Исбер',
    },
    {
      id: 9,
      date: '17 Jun 2019',
      time: '17:30',
      direction: 'Game product',
      game: 'Slots Era',
      platform: 'android',
      event_type: 'client_release',
      description: 'Переподали версию 1.45.0 на 100% аудитории',
      app_version: '1.45.0',
      notes: 'https://wiki.murka.com/pages/viewpage.action?pageId=222177720',
      responsible: 'user.vetal',
    },
  ],
  total: 16,
};

const page2 = {
  data: [
    {
      id: 45,
      date: '24 Jun 2019',
      time: '17:50',
      direction: 'Game product',
      game: 'Slots Era',
      platform: 'ios',
      event_type: 'event_split',
      description:
        'Выключен из раздачи на новичков сплит 106(расчёт среднего чека на сервере с постоянным коэффициентом 0,4). Изменили значения подсплитов settings:2 (было 8), averageCheck:0 (было 1) - т.о. мы перевели всех игроков этого сплита с серверного расчёта среднего чека на клиентский расчёт. Финализирован сплит 105(дефолт, с расчётом среднего чека на клиенте). Коэффициент раздачи сплита игрокам увеличен до 80',
      app_version: 'min_1.44.0',
      notes: 'https://wiki.murka.com/pages/viewpage.action?pageId=228526821',
      responsible: 'Алёна Костина',
    },
    {
      id: 73,
      date: '15 Jun 2019',
      time: '14:30',
      direction: 'Game product',
      game: 'Slots Era',
      platform: 'android',
      event_type: 'client_release',
      description: 'Переподали версию 1.45.0 на 100% аудитории',
      app_version: '1.45.0',
      notes: 'https://wiki.murka.com/pages/viewpage.action?pageId=222177720',
      responsible: 'user.vetal',
    },
    {
      id: 14,
      date: '20 Jun 2019',
      time: '15:30',
      direction: 'Game product',
      game: 'Scatter Slots',
      platform: 'android',
      event_type: 'client_release',
      description: 'Переподали версию 1.45.0 на 100% аудитории',
      app_version: '1.45.0',
      notes: 'https://wiki.murka.com/pages/viewpage.action?pageId=222177720',
      responsible: 'Фадий Исбер',
    },
    {
      id: 23,
      date: '17 Jun 2019',
      time: '17:30',
      direction: 'Game product',
      game: 'Slots Era',
      platform: 'android',
      event_type: 'client_release',
      description: 'Переподали версию 1.45.0 на 100% аудитории',
      app_version: '1.45.0',
      notes: 'https://wiki.murka.com/pages/viewpage.action?pageId=222177720',
      responsible: 'user.vetal',
    },
    {
      id: 24,
      date: '24 Jun 2019',
      time: '17:50',
      direction: 'Game product',
      game: 'Slots Era',
      platform: 'ios',
      event_type: 'event_split',
      description:
        'Выключен из раздачи на новичков сплит 106(расчёт среднего чека на сервере с постоянным коэффициентом 0,4). Изменили значения подсплитов settings:2 (было 8), averageCheck:0 (было 1) - т.о. мы перевели всех игроков этого сплита с серверного расчёта среднего чека на клиентский расчёт. Финализирован сплит 105(дефолт, с расчётом среднего чека на клиенте). Коэффициент раздачи сплита игрокам увеличен до 80',
      app_version: 'min_1.44.0',
      notes: 'https://wiki.murka.com/pages/viewpage.action?pageId=228526821',
      responsible: 'Алёна Костина',
    },
    {
      id: 25,
      date: '15 Jun 2019',
      time: '14:30',
      direction: 'Game product',
      game: 'Slots Era',
      platform: 'android',
      event_type: 'client_release',
      description: 'Переподали версию 1.45.0 на 100% аудитории',
      app_version: '1.45.0',
      notes: 'https://wiki.murka.com/pages/viewpage.action?pageId=222177720',
      responsible: 'user.vetal',
    },
    {
      id: 26,
      date: '20 Jun 2019',
      time: '15:30',
      direction: 'Game product',
      game: 'Scatter Slots',
      platform: 'android',
      event_type: 'client_release',
      description: 'Переподали версию 1.45.0 на 100% аудитории',
      app_version: '1.45.0',
      notes: 'https://wiki.murka.com/pages/viewpage.action?pageId=222177720',
      responsible: 'Фадий Исбер',
    },
    {
      id: 27,
      date: '17 Jun 2019',
      time: '17:30',
      direction: 'Game product',
      game: 'Slots Era',
      platform: 'android',
      event_type: 'client_release',
      description: 'Переподали версию 1.45.0 на 100% аудитории',
      app_version: '1.45.0',
      notes: 'https://wiki.murka.com/pages/viewpage.action?pageId=222177720',
      responsible: 'user.vetal',
    },
  ],
  total: 16,
};

export { page1, page2 };
